import z from "zod";

/**
 * InspecaoObraAprovacaoSchema
 */

export const InspecaoObraAprovacaoSchema = z.object({
  usuario: z.string({ required_error: 'Seu usuário não possui funcionario atribuido!' }),
  data: z.coerce.date({ required_error: 'Este campo deve ser preenchido!' }),
});

/**
 * InspecaoObraAprovacaoForm
 */

export type InspecaoObraAprovacaoForm = z.infer<typeof InspecaoObraAprovacaoSchema>;